import { useWishes } from '../../../../../redux/reducer/content';

export default function useIsShowWishCard() {
  const { data: wishData } = useWishes();
  return Object.values(wishData).every(Boolean);
}
